import {
  Channels,
  DistributionMode,
  EndDateType,
  RedistributionMode,
  ScheduleDays,
} from 'api/offers-domain/offers-domain.types';
import {
  GetDraftMessageResult,
  GetMessageDistributionRulesResult,
  GetMessageDistributionSettingsResult,
  GetMessageResult,
  ListMessagesResult,
  MessageStatusType,
  messageTypes,
} from '../connect-domain.types';

export const messages: ListMessagesResult = {
  paging: {
    total: 7,
    count: 1000,
    totalPages: 1,
    currentPage: 0,
  },
  messages: [
    {
      messageType: messageTypes.PRIVATE,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: null,
      title: 'Draft Welcome Message',
      createdDate: '04/10/2024 10:00:00',
      updatedDate: '04/10/2024 10:15:00',
      noDistributed: 0,
      messageDisplayInfo: [],
      surveyId: null,
      activityNames: [],
      reach: null,
      deleted: false,
      messageStatus: MessageStatusType.DRAFT,
      isDraft: true,
      draftMessageId: '00000000-0000-0000-0000-000000000002',
    },
    {
      messageType: messageTypes.SHAREABLE,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: 'd6669cbc-6bc3-40b6-a24d-e47cd90a9fd6',
      title: 'Activity message SMS testing - 04/03',
      createdDate: '04/03/2024 03:48:30',
      updatedDate: '04/03/2024 03:48:30',
      noDistributed: 2,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'Activity message SMS testing - 04/03',
          shortDescription: 'Activity message SMS testing - 04/03',
          longDescription: 'Activity message SMS testing - 04/03',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/15-152343_envelope-png-cartoon-envelope_960ad55924b14cd593f381dcee76ae90.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/ed3bd961-de11-4710-8792-1aa7194110f8_a44252ea6df042299659c587a367a384.jpg',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: null,
      activityNames: ['CHECK_IN'],
      reach: null,
      deleted: false,
      messageStatus: MessageStatusType.ACTIVE,
    },
    {
      messageType: messageTypes.SHAREABLE,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: '870afc6c-8c04-4c4a-ac20-a89a3a98e6f1',
      title: 'Auto message distribution - 04/02',
      createdDate: '04/02/2024 09:56:10',
      updatedDate: '04/02/2024 09:56:10',
      noDistributed: 28719,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'Auto message distribution - 04/02',
          shortDescription: 'Auto message distribution - 04/02',
          longDescription: 'Auto message distribution - 04/02',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/15-152343_envelope-png-cartoon-envelope_839cd9f74b7a4f9ea3837aec057f548b.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/c73def6e-3391-4ac6-97ae-f58d7b360769_0cd6aeedc68d4b77b23d40484525b753.jpg',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: null,
      activityNames: [],
      reach:
        '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;0d18d2b3-7de0-4e16-b68e-f28a92bb8737;*"]',
      deleted: false,
      messageStatus: MessageStatusType.SCHEDULED,
    },
    {
      messageType: messageTypes.PRIVATE,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: '82a8338e-bb18-4d0d-a348-97d691666196',
      title: 'Auto "Beer Program" enable msg disable-03/27',
      messageStatus: MessageStatusType.EXPIRED,
      createdDate: '03/27/2024 08:34:39',
      updatedDate: '03/27/2024 08:34:39',
      noDistributed: 4,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'Auto "Beer Program" enable msg disable-03/27',
          shortDescription: 'Auto "Beer Program" enable msg disable-03/27',
          longDescription: 'Auto "Beer Program" enable msg disable-03/27',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/beer%202_95b91c955ce64279ab15d3407baf4050.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/230c1e0c-8530-4897-a0ee-caddb4e8ee73_15d92131d5b74913b1f860f4846531b7.png',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: null,
      activityNames: [],
      reach: null,
      deleted: false,
    },
    {
      messageType: messageTypes.PRIVATE,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: 'c43f7bae-b384-4c45-aba7-52191d5a80b8',
      title: 'Auto "Beer Program" enable msg enable-03/27',
      messageStatus: MessageStatusType.ACTIVE,
      createdDate: '03/27/2024 08:33:01',
      updatedDate: '03/27/2024 08:33:01',
      noDistributed: 7,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'Auto "Beer Program" enable msg enable-03/27',
          shortDescription: 'Auto "Beer Program" enable msg enable-03/27',
          longDescription: 'Auto "Beer Program" enable msg enable-03/27',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/png-transparent-beer-alcohol-drinks-beer-cup_73e729d9b3c6481691421260912b1528.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/ce3894a4-cdb6-4fe6-9139-fd7a960e27d2_1beca288ab3c4b89b835220ff63c6853.png',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: null,
      activityNames: [],
      reach: null,
      deleted: false,
    },
    {
      messageType: messageTypes.PRIVATE,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: '8bccaab7-e1d7-43bb-8939-8168f6244a57',
      title: 'Auto "Beer Enthusiast Program" enable msg-03/27',
      messageStatus: MessageStatusType.ACTIVE,
      createdDate: '03/27/2024 02:22:27',
      updatedDate: '03/27/2024 02:22:27',
      noDistributed: 1,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'Auto "Beer Enthusiast Program" enable msg-03/27',
          shortDescription: 'Auto "Beer Enthusiast Program" enable msg-03/27',
          longDescription: 'Auto "Beer Enthusiast Program" enable msg-03/27',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/download%20%281%29_6fdd4957ccfe4ab08defcc47a578c481.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/ca8fc555-f238-46f9-8fa7-74308bb6f6cc_3fe60ba66c4b49d7935c273e4f5eec27.png',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: null,
      activityNames: [],
      reach: null,
      deleted: false,
    },
    {
      messageType: messageTypes.PRIVATE,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: '475cbc95-38d7-4ac2-9c82-9c57e586d6d8',
      title: 'Auto "Beer Enthusiast Program" disable msg-03/27',
      messageStatus: MessageStatusType.EXPIRED,
      createdDate: '03/27/2024 02:19:47',
      updatedDate: '03/27/2024 02:19:47',
      noDistributed: 0,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'Auto "Beer Enthusiast Program" disable msg-03/27',
          shortDescription: 'Auto "Beer Enthusiast Program" disable msg-03/27',
          longDescription: 'Auto "Beer Enthusiast Program" disable msg-03/27',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/download_6cfbb5566a264937bc25f40e87ac98ff.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/a00f3b05-9e5b-4f52-b9ab-d1366aa589e4_243af57dae1045b19726379dd3415a6c.jpg',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: null,
      activityNames: [],
      reach: null,
      deleted: false,
    },
    {
      messageType: messageTypes.SURVEY,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: 'efd7ef40-1171-4dbc-b00a-0e825074c3ec',
      title: 'survey-kav-testing-10-limit',
      messageStatus: MessageStatusType.ACTIVE,
      createdDate: '03/12/2024 03:51:34',
      updatedDate: '03/12/2024 04:25:16',
      noDistributed: 4,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'survey-kav-testing-10-limit',
          shortDescription: 'survey-kav-testing-10-limit',
          longDescription:
            'Open your mobile app, or click {here} and sign in to your account to answer the survey in your inbox.',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/pear_7daea9559a794ff0a46add3315d72a97.png',
          mediumImage: '',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: '65efd061deba8f7aa792d3b2',
      activityNames: ['CHECK_IN'],
      reach: null,
      deleted: false,
    },
    {
      messageType: messageTypes.SURVEY,
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      campaignId: 'ad8baf30-9d28-4c22-ab37-c86da9946fe7',
      messageId: '4a1c3fe3-4622-4943-9f50-4fb320781de4',
      title: 'kav-testing',
      messageStatus: MessageStatusType.SCHEDULED,
      createdDate: '03/11/2024 07:09:56',
      updatedDate: '03/11/2024 07:18:54',
      noDistributed: 3,
      messageDisplayInfo: [
        {
          languageCode: 'EN',
          title: 'kav-testing',
          shortDescription: 'kav-testing',
          longDescription:
            'Open your mobile app, or click {here} and sign in to your account to answer the survey in your inbox.',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/icon_c2bdbfb799f24e3195ed5f51def97c94.png',
          mediumImage: '',
          shareTitle: null,
          shareSentence: null,
          shareShortDesc: null,
          shareURL: null,
        },
      ],
      surveyId: '65eb097e267aa30348f804f4',
      activityNames: ['CHECK_IN'],
      reach: null,
      deleted: false,
    },
  ],
};

const messageBase = {
  messageType: messageTypes.PRIVATE,
  merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
  programId: 'a5fda9aa-8940-433b-856f-7b46b80876a8',
  campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
  messageId: '82a8338e-bb18-4d0d-a348-97d691666196',
  title: 'Test Message',
  createdDate: '09/10/2024 17:34:52',
  updatedDate: '09/10/2024 18:02:25',
  noDistributed: null,
  messageDisplayInfo: [
    {
      languageCode: 'EN',
      title: 'Test Message',
      shortDescription: 'Short Description',
      longDescription: 'Long Description',
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/test-document-upload-fail_188eb787a7224935a48feaf89a0ec0e0.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/test-document-upload-fail_be7ffff307bf4f97b28198bc1e73ccde.png',
      shareTitle: null,
      shareSentence: null,
      shareShortDesc: null,
      shareURL: null,
    },
  ],
  surveyId: null,
  activityNames: [],
  reach: null,
  deleted: false,
  enableReach: false,
  distributionStores: [],
  templateId: null,
};

export const getMessageDistributionSettings: GetMessageDistributionSettingsResult =
  {
    channels: [Channels.INAPP],
    channelTemplateSetMap: {
      SMS: [],
    },
    distributionMode: DistributionMode.AUTO,
    redistributionMode: RedistributionMode.ONCE,
    distributionStartDate: '2024-09-12T00:00',
    distributionEndDate: null,
    distributionEndDateType: EndDateType.NEVER_EXPIRE,
    distributionSchedule: {
      startDate: '09/12/2024 00:00:00',
      endDate: null,
      scheduleDays: [ScheduleDays.TUESDAY],
      timeSlots: [
        {
          startTime: '03:00:00',
          endTime: '04:00:00',
        },
        {
          startTime: '06:00:00',
          endTime: '07:00:00',
        },
      ],
    },
    numMessagesToDistribute: 100000000000000000,
    timezone: 'Asia/Kabul',
  };

export const getMessageDistributionRules: GetMessageDistributionRulesResult = {
  messageId: '82a8338e-bb18-4d0d-a348-97d691666196',
  ruleSet:
    '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"NO_ONE"}',
  personaId: null,
  enableReach: true,
  reach:
    '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;0d18d2b3-7de0-4e16-b68e-f28a92bb8737;*"]',
  reachDisplayInfo: null,
};

export const getMessage: GetMessageResult = {
  ...getMessageDistributionSettings,
  ...getMessageDistributionRules,
  ...messageBase,
};

export const getDraftMessage: GetDraftMessageResult = {
  ...messageBase,
  draftMessageId: '00000000-0000-0000-0000-000000000002',
  isDraft: true,
};
